import {
  Portal as ChakraPortal,
  PortalProps as ChakraPortalProps,
} from "@chakra-ui/react";
import type { RefObject } from "react";
import type { PortalSharedProps } from "./Portal.props";

type PortalPropsExtended = PortalSharedProps &
  Omit<ChakraPortalProps, "container"> & {
    /** Chakra v1/v2 prop - ref to container element */
    containerRef?: RefObject<HTMLElement | null>;
    /** Chakra v3 prop - ref to container element */
    container?: RefObject<HTMLElement | null>;
  };

export default function Portal(props: PortalPropsExtended): JSX.Element {
  const { containerRef, container, children, ...rest } = props;
  // Support both v1/v2 containerRef and v3 container props
  // In Chakra v3, container expects a RefObject
  const containerValue = container ?? containerRef;

  // If no container specified, render children directly in Portal
  // If container is specified but current is null, also just use default portal
  if (!containerValue?.current) {
    return <ChakraPortal {...rest}>{children}</ChakraPortal>;
  }

  return (
    <ChakraPortal container={containerValue} {...rest}>
      {children}
    </ChakraPortal>
  );
}

export type PortalProps = PortalPropsExtended;
